<template>
  <div>
    <div>
      <el-row>
        <el-col :span="15">
          <h3>
            运维值班人员列表
            <el-button type="success" @click="onDuty">运维值班签到</el-button>
            <!-- <el-button type="info" icon="el-icon-refresh" @click="queryDutyList" circle></el-button> -->
          </h3>
          <div class="on-duty-container">
            <div class="on-duty-item" v-for="item in dutyList" :key="item.id">
              <div><el-avatar icon="el-icon-user-solid"></el-avatar></div>
              <div>{{ item.userName }}</div>
              <div>
                <el-tag size="mini" type="success">值班中</el-tag>
                <el-tag size="mini" type="warning">
                  <span v-if="item.type == 'morning'">早班</span>
                  <span v-if="item.type == 'evening'">晚班</span>
                </el-tag>
              </div>
              <div>签到时间:<el-tag size="mini" type="warning">{{item.updateTime}}</el-tag></div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <h3>
            WEB监控日志
            <el-button
              type="success"
              icon="el-icon-refresh"
              circle
              @click="tweeterRefresh"
            ></el-button>
          </h3>
          <div class="block">
            <el-timeline>
              <el-timeline-item
                v-for="item in webMonitor"
                :key="item.id"
                :timestamp="item.createTimeStr"
              >
                <el-card>
                <h4>{{ item.content }}</h4>
              </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="值班签到"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span style="color: red"
        >注意:值班状态会同步发送到相关钉钉群中，请知悉!!</span
      >
      <el-form>
        <el-form-item label="签到人员:">
          {{ userInfo.userName }}
        </el-form-item>
        <el-form-item label="工作状态:">
          <el-select v-model="duty.workMode" placeholder="请选择工作状态">
            <el-option label="值班中" value="on_duty"></el-option>
            <el-option label="已下班" value="free"></el-option>
            <el-option label="请假中" value="ask_for_leave"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值班类型:">
          <el-select v-model="duty.type" placeholder="值班类型">
            <el-option label="早班" value="morning"></el-option>
            <el-option label="晚班" value="evening"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumitOnDutyForm">签到</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style>
.on-duty-container {
  display: inline-flex;
}
.on-duty-item {
  color: rgb(172, 171, 171);
  margin-right: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
</style>
<script>
import { getLocalStorageItem } from "@/utils/localstorage/LocalstorageKit";
import SysRobotApi from "@/api/SysRobotApi";
import TweeterApi from "@/api/TweeterApi";

import DutyApi from "@/api/DutyApi";
export default {
  name: "Welcome",
  data() {
    return {
      centerDialogVisible: false,
      userInfo: {},
      duty: {
        userName: "",
        workMode: "",
        type: "",
        userId: "",
      },
      dutyList: [],
      webMonitor: [],
    };
  },
  mounted() {
    this.userInfo = JSON.parse(getLocalStorageItem("userInfo"));
    this.duty.userId = this.userInfo.userRelId;
    this.queryDutyList();
    this.tweeterRefresh();
  },
  methods: {
    queryDutyList() {
      DutyApi.dutyList().then((resp) => {
        if (resp.state == "OK") {
          this.dutyList = resp.data;
        }
      });
    },
    initMyDuty() {
      let data = this.duty;
      DutyApi.initMyDuty(data).then((resp) => {
        if (resp.state == "OK") {
          this.duty.workMode = resp.data.workMode;
          this.duty.type = resp.data.type;
          this.duty.id = resp.data.id;
        }
      });
    },
    onDuty() {
      this.centerDialogVisible = true;
      this.initMyDuty();
    },
    sumitOnDutyForm() {
      //保存当前值班状态到后台接口中，然后发送消息
      let data = this.duty;
      DutyApi.reportOnDuty(data).then((resp) => {
        this.duty.userName = this.userInfo.userName;
        let status = {
          morning: "早班",
          evening: "晚班",
        };
        let content = `通知:\n今天[${this.duty.userName}]值班\n值班班次：${
          status[this.duty.type]
        }\n请各位同事有事群里叫我，值班人员列表在千里眼监控平台可以查询。`;
        if (this.duty.workMode == "free") {
          content = `通知:\n今天[${this.duty.userName}]已经换班\n请各位同事有事群里呼叫其他同事，值班人员列表在千里眼监控平台可以查询。`;
        } else if (this.duty.workMode == "ask_for_leave") {
          content = `通知:\n今天[${this.duty.userName}]有事请假\n请各位同事有事群里呼叫其他同事，值班人员列表在千里眼监控平台可以查询。`;
        }
        let params = {
          atAll: false,
          content: content,
          mobiles: ["13641489216"],
          robotId: "service-monitor",
        };
        SysRobotApi.checkRobot(params).then((resp) => {
          if (resp.state == "OK") {
            this.$successMsg(resp.msg);
            this.centerDialogVisible = false;
            this.queryDutyList();
          } else {
            this.$errorMsg(resp.msg);
          }
        });
      });
    },
    tweeterRefresh() {
      TweeterApi.queryWebMonitorTweeter().then((resp) => {
        if (resp.state == "OK") {
          this.webMonitor = resp.data.records;
        }
      });
    },
  },
};
</script>
